import React from 'react';

import { withRouter, RouteComponentProps } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux'

import {
    CommandBar, DefaultButton, Dialog, DialogFooter, DialogType, IButtonProps, ICommandBarItemProps,
    ICommandBarStyles, IDialogContentProps, PrimaryButton, MessageBarType, IChoiceGroup, Panel,
    PanelType, IPanelStyles, Text, mergeStyleSets
} from '@fluentui/react';

import CustomCommandBarMenuItem from '../../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';
import { reduxActions, RootState } from '../../../store';
import { IFile, IProtocol } from '../../../shared/interfaces';
import { Unsubscribe } from '@casl/ability';
import abilityBuild from '../../../shared/CASL/appAbility';
import CustomCommandBarButton from '../../CustomFluentUI/CustomCommandBarButton/CustomCommandBarButton';
import RippleLoader from '../../Loader/RippleLoader/RippleLoader';
import { checkRoles } from '../../../hoc/CheckRoles';
import { Protocol_State, Protocol_Type, RoleContext, Visibility_Type } from '../../../shared/enums';
import pecmailService from '../../../services/pecmail.service';
import PdfViewer from '../../PdfViewer/PdfViewer';
import MailProtocolWizardFileList from './MailProtocolWizardFileList';
import AppUtilities from '../../../shared/Utilities/appUtilities';
import protocolsService from '../../../services/protocols.service';
import { MailProtocolWizardReduxState } from '../../../store/mail-protocol-wizard/types';
import CircleLoader from '../../Loader/CircleLoader/CircleLoader';
import axios, { CancelTokenSource } from 'axios';
import Utilities from '../../../shared/Utilities/utilities';
import { toastRef } from '../../Layout/Layout';
import DOMPurify from "dompurify";


const queryString = require('query-string');

const styles = mergeStyleSets({
    subject: {
        marginBottom: 12,
        paddingLeft: 20,
        paddingRight: 20,
        fontWeight: 'bold',
        lineHeight: '1.35em'
    },
    from: {
        display: 'block',
        paddingLeft: 20,
        paddingRight: 20,
        marginTop: 15,
        lineHeight: '1.35em'
    },
    body: {
        display: 'block',
        paddingLeft: 20,
        paddingRight: 20,
        marginTop: 15,
    },
    toAndDate: {
        display: 'block',
        marginTop: 5,
        fontWeight: 'thin',
        paddingLeft: 20,
        paddingRight: 20,
        color: '#666'
    },
});
const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: [], // CommandBar will determine items rendered in overflow
        isBeakVisible: true,
        beakWidth: 20,
        gapSpace: 10,
    },
};

const panelStyles: Partial<IPanelStyles> = {
    scrollableContent: {
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        flexFlow: 'column'
    },
    content: {
        padding: '24px 20px 0px',
        height: "100%",
        overflow: "hidden"
    }
}

const pivotBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 14px' }
};

const domPurifyProps = {
    FORBID_TAGS: ['head']
};

const documentPivotBarDefaultItems: ICommandBarItemProps[] = [];


const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
    currentUor: state.sessionReducer.currentUor,
    currentUser: state.sessionReducer.currentUser,
    allRoles: state.sessionReducer.allRoles,
    lateralPanelMailProtocolWizardIsOpen: state.mailProtocolWizardReducer.lateralPanelMailProtocolWizardIsOpen,
    selectedMail: state.mailProtocolWizardReducer.selectedMail,
    selectedMailboxAddress: state.mailProtocolWizardReducer.selectedMailboxAddress,
    selectedDocument: state.mailProtocolWizardReducer.selectedDocument,
    fileListOptions: state.mailProtocolWizardReducer.fileListOptions,

    features: state.sessionReducer.features,
    isMobile: state.sessionReducer.isMobile,
})
const mapDispatch = {
    updateMailProtocolWizardState: (newState: Partial<MailProtocolWizardReduxState>) => (reduxActions.mailProtocolWizardActions.updateMailProtocolWizardState(newState)),

}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface MailProtocolWizardProps {
}

export interface MailProtocolWizardState {
    commandBarItems: ICommandBarItemProps[],
    documentPivotBarItems: ICommandBarItemProps[],
    documentPivotBarSelectedKey: string | null,
    detailsPivotBarItems: ICommandBarItemProps[],
    detailsPivotBarSelectedKey: string,
    showActionsLoader: boolean,
    showMessageBar: boolean
    messageBarType: MessageBarType,
    messageBarText: string
    confirmDialogIsOpen: boolean,
    confirmDialogContentProps: IDialogContentProps,
    confirmDialogSubmitFunction: Function,
    loadingComponent: boolean
}

type Props = MailProtocolWizardProps & RouteComponentProps & PropsFromRedux

class MailProtocolWizard extends React.Component<Props, MailProtocolWizardState> {

    uploadInputRef = React.createRef<HTMLInputElement>();
    choiceGroupRef = React.createRef<IChoiceGroup>();
    filingPlanTreeRef = React.createRef();

    unsubscribeFromAbility: Unsubscribe = () => { };

    state: MailProtocolWizardState = {
        // uso l’operatore .slice() per creare una copia di defaultCommandBarItem altrimenti avrei un riferimento a defaultCommandBarItem
        commandBarItems: [],
        documentPivotBarItems: documentPivotBarDefaultItems.slice(),
        documentPivotBarSelectedKey: null,
        detailsPivotBarItems: [],
        detailsPivotBarSelectedKey: 'fileList',
        showActionsLoader: false,
        showMessageBar: false,
        messageBarType: MessageBarType.info,
        messageBarText: "",
        confirmDialogIsOpen: false,
        confirmDialogContentProps: {},
        confirmDialogSubmitFunction: () => { },
        loadingComponent: true
    }

    cancelTokenSources = {};

    componentDidMount() {
        this.unsubscribeFromAbility = abilityBuild.on('updated', () => { });
        this.updateDocumentAndDetailsPivotBarItems();
        this.getAllFiles();


    }


    componentDidUpdate(oldProps: Props, oldState: MailProtocolWizardState) {

        if (this.props.isMobile && oldProps.isMobile !== this.props.isMobile) {
            this.updateDocumentAndDetailsPivotBarItems();
        }
        if (oldProps.selectedMail !== this.props.selectedMail) {
            this.getAllFiles();
        }
    }

    componentWillUnmount() {
        this.unsubscribeFromAbility();
        // cancello tutte le request in pending
        for (const [key, value] of Object.entries<CancelTokenSource>(this.cancelTokenSources)) {
            value.cancel(`${key} canceled`)
        }
    }

    // Click sul button nel footer del Panel
    submitCreateDraftFromMailLateralPanel = async (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        let fileName = this.props.selectedDocument?.originalName ? this.props.selectedDocument?.originalName : this.props.selectedDocument?.fileName;

        this.setState({
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.largeHeader,
                title: 'Creazione protocollo',
                subText: `Vuoi creare un protocollo con documento principale: ${fileName}`,
            },
            confirmDialogSubmitFunction: () => { this.submitCreateDraftFromMailConfirmDialog() }

        })

    }
    dismissCreateDraftFromMailLateralPanel = () => {
        this.props.updateMailProtocolWizardState({ lateralPanelMailProtocolWizardIsOpen: false });
    }

    // Click su conferma del dialog per la creazione del protocollo
    submitCreateDraftFromMailConfirmDialog = async () => {
        if (this.props.currentAoo && this.props.currentUor && this.props.selectedMail && this.props.selectedMailboxAddress && this.props.selectedDocument) {
            this.setState({ confirmDialogIsOpen: false })

            let { currentAoo, currentUor, selectedMail, selectedDocument } = this.props;

            // il documento principale è sicuramente un pdf perchè se è un altro tipo di file viene convertito in pdf in automatico da getbase64ForMailAttachment 
            // però il nome del file non viene modificato quindi se il file originale non era un pdf ma ad esempio un docx, allora aggiorno l'estensione
            let fileName = selectedDocument.originalName ? selectedDocument.originalName : selectedDocument.fileName;
            let fileExtension = AppUtilities.getExtensionFromFilename(fileName);
            if (fileExtension.toLowerCase() !== ".pdf") {
                selectedDocument.fileName = AppUtilities.replaceExtension(fileName, ".pdf");
                selectedDocument.extension = ".pdf";
            }

            const documentFile = protocolsService.convertFileSPToIFile(selectedDocument);
            this.setState({ showActionsLoader: true });

            let draftProtocol: IProtocol = {

                statoProtocollo: Protocol_State.InCreazioneDaMail,
                tipoProtocollo: Protocol_Type.DocumentoInEntrata,
                visibilita: [{ uor: currentUor, tipologia: Visibility_Type.Proprietario }],
                fields: [{
                    displayName: "Oggetto protocollo",
                    internalName: "OggettoProtocollo",
                    internalValue: selectedMail.subject.substring(0, 255),
                    sharepointType: "Text",
                    controlType: "textbox",
                    required: true,
                    readonly: false,
                    disabled: false,
                    system: false,
                    valid: true,
                    touched: true
                },
                {
                    displayName: "Mittente esterno",
                    internalName: "MittenteEsterno",
                    internalValue: selectedMail.from,
                    sharepointType: "Text",
                    controlType: "textbox",
                    required: false,
                    readonly: false,
                    disabled: false,
                    system: false,
                    valid: true,
                    touched: true
                }],
                documentFile: { ...documentFile, id: 0 } // setto l'id a zero perchè l'id si riferisce all'id del file nel Pec&Mail
            }


            protocolsService
                .createDraftFromPecMail(currentAoo.id, currentUor.id!, draftProtocol, this.props.selectedMail.id, this.props.selectedMailboxAddress)
                .then(draftId => {
                    try {
                        this.props.history.push({ pathname: `/${currentAoo.id}/edit/${draftId}`, search: this.props.location.search })
                        this.dismissCreateDraftFromMailLateralPanel();
                        this.setState({ showActionsLoader: false });
                    } catch (error: any) {
                        console.error("createDraftFromPecMail", error);
                        // Creare un oggetto con tutte le proprietà dell'errore
                        const errorDetails = {
                            message: error.message,
                            name: error.name,
                            stack: error.stack
                        };

                        localStorage.setItem(`createDraftFromPecMailThen`, JSON.stringify(errorDetails));

                        throw error;
                    }
                })
                .catch(error => {
                    const errorDetails = {
                        message: error.message,
                        name: error.name,
                        stack: error.stack
                    };
                    localStorage.setItem(`createDraftFromPecMailService`, JSON.stringify(errorDetails));

                    if (error.code === 'ECONNABORTED') {
                        toastRef.current?.show({ severity: 'error', summary: "Attenzione", detail: `Creazione bozza non riuscita`, life: 5000 });
                    }
                    else if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: "Attenzione",
                            detail: 'Errore nella creazione della bozza del protocollo',
                            life: 5000
                        });
                    }
                    this.setState({
                        showActionsLoader: false
                    });
                });
        }

    }
    dismissConfirmDialog = () => {
        this.setState({ confirmDialogIsOpen: false })
    }


    getAllFiles = () => {

        let files: IFile[] = [];

        const parsedQueryString = queryString.parse(this.props.location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

        if (this.props.currentAoo && uorId && this.props.selectedMailboxAddress && this.props.selectedMail) {

            this.props.selectedMail!.attachments.forEach(el => {
                let extension = AppUtilities.getExtensionFromFilename(el.nomeFile);
                let enabled = AppUtilities.extensionsAllowedForProtocolDocument.findIndex(el => el.toLowerCase() === extension.toLowerCase()) >= 0;
                let file: IFile = {
                    id: el.id,
                    fileName: el.nomeFile,
                    docBase64String: "",
                    loading: false,
                    extension: extension,
                    dimension: el.dimensione,
                    dimensionUnit: 'B', // la dimnesione nel pecmail è sempre in B
                    enabled: enabled
                }
                files.push(file);
            });
            files = files.sort(AppUtilities.compareFileEnableBeforeDisabled);

            let corpoMailFile = {
                id: 0,
                docBase64String: undefined,
                dimension: 0,
                dimensionUnit: 'B',
                fileName: 'Corpo della mail.pdf',
                extension: '.pdf',
                enabled: true,

            };
            files.splice(0, 0, corpoMailFile);

            this.props.updateMailProtocolWizardState({ fileListOptions: files, selectedDocument: corpoMailFile });
            this.setState({ loadingComponent: false });

        }
    }

    onDocumentPivotBarItemClick = (selectedItemKey: string) => {
        let _pivotItems = this.remapCommandBarItemsAsPivotItems(this.state.documentPivotBarItems, selectedItemKey, this.onDocumentPivotBarItemClick);
        this.setState({ documentPivotBarSelectedKey: selectedItemKey, documentPivotBarItems: _pivotItems });
    }

    onDetailsPivotBarItemClick = (selectedItemKey: string) => {
        let _pivotItems = this.remapCommandBarItemsAsPivotItems(this.state.detailsPivotBarItems, selectedItemKey, this.onDetailsPivotBarItemClick);
        this.setState({ detailsPivotBarSelectedKey: selectedItemKey, detailsPivotBarItems: _pivotItems });
    }

    onUploadButtonClick = () => {
        if (this.uploadInputRef && this.uploadInputRef.current) {
            this.uploadInputRef.current.click();
        }
    };


    onFileClick = (file?: IFile) => {
        let _pivotItems = [...this.state.documentPivotBarItems];
        if (file) {
            let allegato: ICommandBarItemProps = {
                key: 'allegato',
                text: file.fileName,
            };

            let tabAllegatoIndex = _pivotItems.findIndex(it => it.key === 'allegato');
            if (tabAllegatoIndex < 0) {
                _pivotItems.splice(1, 0, allegato);
            }
            else {
                _pivotItems.splice(tabAllegatoIndex, 1, allegato);
            }
            _pivotItems = this.remapCommandBarItemsAsPivotItems(_pivotItems, 'allegato', this.onDocumentPivotBarItemClick);

            this.props.updateMailProtocolWizardState({
                selectedDocument: file,
            });

            if (file.fileName === "Corpo della mail.pdf") {
                this.setState({
                    documentPivotBarItems: _pivotItems,
                    documentPivotBarSelectedKey: 'allegato',
                });

            }
            else {

                const parsedQueryString = queryString.parse(this.props.location.search);
                let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

                // se in cancelTokenSources c'è il cancelToken associato alla chiamata
                // chiamo il metodo cancel che interrompe la chiamata in pending
                this.cancelTokenSources[pecmailService.getBase64ForMailAttachment.name]?.cancel("Request annullata");

                // Creo un cancel token
                this.cancelTokenSources[pecmailService.getBase64ForMailAttachment.name] = axios.CancelToken.source();

                

                pecmailService.getBase64ForMailAttachment(this.props.currentAoo!.id, uorId, this.props.selectedMailboxAddress!, this.props.selectedMail?.id! ,file.id!, this.cancelTokenSources[pecmailService.getBase64ForMailAttachment.name].token)
                    .then(fileResult => {
                        file.fileName = AppUtilities.extractOriginalFileNameFromP7M(file.fileName)
                        file.extension = AppUtilities.getExtensionFromFilename(file.fileName);

                        file.docBase64String = fileResult;
                        file.loading = false;

                        this.setState({
                            documentPivotBarItems: _pivotItems,
                            documentPivotBarSelectedKey: 'allegato'
                        });
                        this.props.updateMailProtocolWizardState({
                            selectedDocument: file,
                        });

                        //let newfileList = this.props.fileListOptions ? [...this.props.fileListOptions] : [];

                        //let index = newfileList.findIndex(el => el.id === newFile.id);
                        //if (index != -1) {
                        //    newfileList[index] = newFile;
                        //    this.props.updateMailProtocolWizardState({ fileListOptions: newfileList });
                        //}
                        delete this.cancelTokenSources[pecmailService.getBase64ForMailAttachment.name];

                    })
                    .catch(error => {
                        if (axios.isCancel(error)) {
                            //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                            console.log(error.message);
                        } else {
                            throw error;
                        }
                    });
            }
        }
        else {
            _pivotItems.splice(0, 1);
            this.setState({
                documentPivotBarItems: _pivotItems,
                documentPivotBarSelectedKey: null,
            });

            this.props.updateMailProtocolWizardState({
                selectedDocument: file,
            });

        }

    }


    remapCommandBarItemsAsPivotItems = (items: ICommandBarItemProps[], selectedItemKey: string | null, onClickFunction: Function) => {

        return items.map(it => {
            let _className = 'commandbar-as-pivot';
            if (it.key === selectedItemKey)
                _className += ` isSelected`;


            return (
                {
                    ...it,
                    onClick: () => { onClickFunction(it.key); },
                    commandBarButtonAs: () => (
                        <CustomCommandBarButton text={it.text}
                            key={it.key}
                            className={_className}
                            onClick={() => { onClickFunction(it.key); }} />
                    )
                }
            );
        });
    }




    updateDocumentAndDetailsPivotBarItems = () => {
        const { documentPivotBarItems } = this.state;

        let newDocumentPivotBarItems = documentPivotBarDefaultItems.slice();

        if (documentPivotBarItems && documentPivotBarItems.length > 0)
            newDocumentPivotBarItems = [...documentPivotBarItems];

        let detailsPivotBarItems: ICommandBarItemProps[] = [];
        detailsPivotBarItems.push(...[
            {
                key: 'fileList',
                text: 'Elenco file',
            }
        ]);



        if (this.props.isMobile) {
            let newdocumentPivotBarItems = [...newDocumentPivotBarItems, ...detailsPivotBarItems];
            let documentPivotBarItemsRemap = this.remapCommandBarItemsAsPivotItems(newdocumentPivotBarItems, this.state.documentPivotBarSelectedKey, this.onDocumentPivotBarItemClick)

            this.setState({ documentPivotBarItems: documentPivotBarItemsRemap, detailsPivotBarItems: [] });

        }
        else {
            let documentPivotBarItemsRemap = this.remapCommandBarItemsAsPivotItems(newDocumentPivotBarItems, this.state.documentPivotBarSelectedKey, this.onDocumentPivotBarItemClick)
            let detailsPivotBarItemsRemap = this.remapCommandBarItemsAsPivotItems(detailsPivotBarItems, this.state.detailsPivotBarSelectedKey, this.onDetailsPivotBarItemClick)

            this.setState({ documentPivotBarItems: documentPivotBarItemsRemap, detailsPivotBarItems: detailsPivotBarItemsRemap });

        }
    }

    submitDownloadDocument = () => {
        this.setState({ confirmDialogIsOpen: false })
        if (this.props.selectedDocument && this.props.selectedDocument.docBase64String && this.props.selectedDocument.fileName) {
            let fileBase64string = this.props.selectedDocument.docBase64String;
            let fileName = this.props.selectedDocument.fileName
            Utilities.SaveFileFromBase64(fileBase64string, fileName);
        }
    }
    onDocumentError = () => {

        if (this.props.selectedDocument && this.props.selectedDocument.docBase64String && this.props.selectedDocument.fileName) {
            this.setState({
                confirmDialogIsOpen: true,
                confirmDialogContentProps: {
                    type: DialogType.largeHeader,
                    title: 'Anteprima non disponibile',
                    subText: `Vuoi scaricare una copia del documento?`,
                },
                confirmDialogSubmitFunction: () => { this.submitDownloadDocument() }

            })


        }
    }


    renderPivotContent = (pivotKey) => {
        switch (pivotKey) {
            case 'allegato':
                const mySafeHTML = DOMPurify.sanitize(this.props.selectedMail?.body, domPurifyProps);
                return (
                    <div className={`position-relative my-scroll-div`}>
                        {this.props.selectedDocument?.fileName === 'Corpo della mail.pdf' ?
                            <React.Fragment>
                                <div className="mail-head">
                                    <div className="title-infobtn-container">
                                        <div className="mail-info" style={{ marginTop: 20 }}>
                                            <Text className={styles.subject} nowrap>
                                                {this.props.selectedMail?.subject}
                                            </Text>
                                        </div>
                                    </div>
                                    <div className="mail-info-actions-container">
                                        <div className="mail-info">
                                            <Text className={styles.from} nowrap>
                                                {this.props.selectedMail?.from}
                                            </Text>
                                            <Text className={styles.toAndDate} nowrap>
                                                {AppUtilities.FormatDate(this.props.selectedMail?.date, false)}
                                            </Text>

                                            <Text className={styles.toAndDate} nowrap>
                                                A: {this.props.selectedMail?.to.map(el => el + "; ")}
                                            </Text>

                                            {this.props.selectedMail?.cc && this.props.selectedMail?.cc.length > 0 &&
                                                <Text className={styles.toAndDate} nowrap>
                                                    Cc: {this.props.selectedMail.cc.map(el => el + "; ")}
                                                </Text>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <hr className="mail-head-hr" />

                                <div className="mail-body-wrapper position-relative">
                                    <div className={`position-relative my-scroll-div`}>
                                        <div className={styles.body}>
                                            <div dangerouslySetInnerHTML={{ __html: mySafeHTML }} />
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                            :
                            <PdfViewer base64String={this.props.selectedDocument?.docBase64String} initialLoading={true} onLoadDocumentError={() => this.onDocumentError()} />
                        }
                    </div>
                );
            case 'fileList':
                return (
                    <div className={`position-relative my-scroll-div`}>
                        <MailProtocolWizardFileList
                            {...this.props}
                            onFileClick={this.onFileClick}

                        />
                    </div>

                );

        }
    }

    onRenderFooterCreateProtocolLateralPanel = () => {
        let someFileIsLoading = this.props.fileListOptions?.findIndex(el => el.loading === true) !== -1;

        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Crea"
                    disabled={!this.props.selectedDocument || someFileIsLoading}
                    onClick={this.submitCreateDraftFromMailLateralPanel}

                />
                <DefaultButton
                    onClick={this.dismissCreateDraftFromMailLateralPanel}
                    text="Annulla"
                />
            </React.Fragment>
        );
    }


    render() {


        let loaderClass = this.state.showActionsLoader ? "active" : '';
        return (
            <Panel
                key='MailProtocolWizardPanel'
                isOpen={this.props.lateralPanelMailProtocolWizardIsOpen}
                type={PanelType.custom}
                customWidth={'70%'}
                styles={panelStyles}
                headerText="Selezione del documento principale"
                focusTrapZoneProps={{
                    isClickableOutsideFocusTrap: true,
                    forceFocusInsideTrap: true,
                }}
                onDismiss={this.dismissCreateDraftFromMailLateralPanel}
                onRenderFooterContent={this.onRenderFooterCreateProtocolLateralPanel}
                // Stretch panel content to fill the available height so the footer is positioned
                // at the bottom of the page
                isFooterAtBottom={false}

            >
                <CircleLoader loaderClass='loader-large' loading={this.state.loadingComponent} />

                <div className={"loader opacity " + loaderClass}>
                    <RippleLoader text='Operazione in corso' />
                </div>
                <div className='pre-protocol-wizard-component flex flex-column p-nogutter'>


                    <div className="component-content flex flex-column lg:flex-row p-nogutter">
                        <div className="details-wrapper hidden md:flex md:col-4 m-0 p-0 flex-column">
                            <CommandBar
                                items={this.state.detailsPivotBarItems}
                                overflowButtonProps={overflowProps}
                                styles={pivotBarStyles}
                            />
                            <div className={'pivot-wrapper'}>

                                {this.renderPivotContent(this.state.detailsPivotBarSelectedKey)}

                            </div>
                        </div>

                        <div className="document-wrapper col-12 md:col-8 flex flex-column p-nogutter">
                            <CommandBar
                                items={[...this.state.documentPivotBarItems]}
                                overflowButtonProps={overflowProps}
                                styles={pivotBarStyles}

                            />
                            <div className={'pivot-wrapper'}>

                                {this.renderPivotContent(this.state.documentPivotBarSelectedKey)}

                            </div>
                        </div>
                    </div>
                    <Dialog
                        hidden={!this.state.confirmDialogIsOpen}
                        onDismiss={this.dismissConfirmDialog}
                        dialogContentProps={this.state.confirmDialogContentProps}

                    >
                        <DialogFooter>
                            <PrimaryButton onClick={() => this.state.confirmDialogSubmitFunction()} text="Conferma" />
                            <DefaultButton onClick={this.dismissConfirmDialog} text="Annulla" />
                        </DialogFooter>

                    </Dialog>




                </div>


            </Panel>
        );
    }
}

export default connector(withRouter(checkRoles(MailProtocolWizard, RoleContext.Uor)));

